import { useState } from 'react'
import { Link } from 'react-router-dom'
import Card from '../UI/Card'
import Button from '../UI/Button'
import { formatPrice } from '../../utils/formatters'
import { formatColorsDisplay, handleBuyInApp } from '../../utils/helpers'
import { STATIC_TEXTS } from '../../utils/constants'

const ProductCard = ({ product, showExploreButton = false, bestSelling = false }) => {
  const [imageError, setImageError] = useState(false)
  const baseUrl =  import.meta.env.VITE_URL_IMAGES_BACK   
  // Extraer datos del producto
  const productImage = product.images?.[0] || '../no-image.png'

  const imageUrl = product.images?.[0] ? `${baseUrl}/images/products/${productImage}` : '../images/no-image.png'
  
  const productName = product.name || 'Sin nombre'
  const firstVariant = product.variants?.[0]
  const price = firstVariant?.public_price || firstVariant?.wholesalers_price || 0
  const colors = product.variants?.map(variant => 
    variant.data_glass_product?.color || variant.colors
  ).filter(Boolean) || []

  const colorDisplay = formatColorsDisplay(colors)
    
  const handleImageError = () => {
    setImageError(true)
  }
    
  const handleBuyClick = (e) => {
    e.preventDefault()
    e.stopPropagation()
    handleBuyInApp()
  }
    
  const handleExploreClick = (e) => {
    e.preventDefault()
    e.stopPropagation()
    // Navegar a la categoría del producto
    window.location.href = `/categoria/${product.data_category?.category || 'general'}`
  }

  return (
    <div className="group relative hover:z-10">
      <Card 
        hover={!showExploreButton}
        padding={false}
        className={`${!showExploreButton && 'transform transition-all duration-300 hover:scale-[1.15]'}`}
      >
        <Link to={`/producto/${product._id}`} className="block">
          {/* Product Image */}
          <div className="relative aspect-square overflow-hidden bg-gray-100">
            {!imageError ? (
              <img
                // src={productImage}
                src={imageUrl} 
                alt={productName}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                onError={handleImageError}
                loading="lazy"
              />
            ) : (
              <img
                // src={productImage}
                src={imageUrl} 
                alt={productName}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                onError={handleImageError}
                loading="lazy"
              />
            )}
          </div>
                    
          {/* Product Info */}
          <div className="p-4 space-y-2 text-center">
            {/* Product Name */}
            <h3 className="font-title font-semibold text-primary-text text-lg leading-tight group-hover:text-primary-dark transition-colors duration-300 whitespace-nowrap overflow-hidden text-ellipsis">
              {productName}
            </h3>
                        
            {/* Color */}
            <p className="font-body font-extralight text-primary-gray uppercase">
              {colorDisplay}
            </p>
                        
            {/* Price */}
            <p className="text-2xl font-title text-primary-text">
              {formatPrice(price)}
            </p>
          </div>
        </Link>

        {showExploreButton && bestSelling ? (
          <div className="p-4 pt-0 text-center mb-4">
            <Button
              variant="ghost"
              size="small"
              onClick={handleExploreClick}
              className='transform translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300'
            >
              {STATIC_TEXTS.BUTTONS.EXPLORE}
            </Button>
          </div>
        ) : (
          <div className="p-4 pt-0">
            <Button
              variant="ghost"
              size="small"
              onClick={handleBuyClick}
              className="w-full opacity-0 transform translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300"
            >
              {STATIC_TEXTS.BUTTONS.BUY_APP}
            </Button>
          </div>
        )}
      </Card>
    </div>
  )
}

export default ProductCard